import { render, staticRenderFns } from "./calcSamples.vue?vue&type=template&id=6d4a9721&lang=pug&"
import script from "./calcSamples.vue?vue&type=script&lang=js&"
export * from "./calcSamples.vue?vue&type=script&lang=js&"
import style0 from "./calcSamples.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports